import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { goBack } from 'react-router-redux';
import Grid from '@material-ui/core/Grid/Grid';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import { match } from 'react-router';

import { AscendState } from '../../ducks';
import { Debt, PaymentSchedule } from '../../models/debt';
import Layout from '../Layout/Layout';
import Title from '../shared/Title/Title';
import { DebtState, getDebtState } from '../../ducks/debt';
import { ADD_DEBT, ADD_PAYMENT, ADD_SCHEDULE, FETCH_DEBT } from '../../ducks/actions';
import * as styles from './SettlementSchedule.css';
import SettlementScheduleForm from '../DebtDetails/SettlementSchedule/SettlementScheduleForm/SettlementScheduleForm';

interface SettlementScheduleProps {
  isMobile: boolean;
  debts: DebtState;
  getDebt: (id: number) => void;
  addDebt: (debtInfo: Debt) => void;
  back: () => void;
  addSchedule: (schedule: PaymentSchedule[], debtId: number) => void;
  addPayment: (payment: PaymentSchedule, debtId: number) => void;
  match: match<{ id: number }>;
}

class SettlementSchedule extends React.Component<SettlementScheduleProps> {
  componentDidMount() {
    const { id } = this.props.match.params;
    if (!this.props.debts.data[id]) {
      this.props.getDebt(id);
    }
  }
  render() {
    const { debts, addSchedule, addPayment, back, isMobile } = this.props;
    const { id } = this.props.match.params;
    const currentDebt = debts.data[id];
    const debtData = currentDebt && currentDebt.data;
    const schedule = debtData && debtData.schedule;
    return (
      <Layout>
        <div>
          <Title text="Settlement Schedule" />
          {currentDebt && currentDebt.loading ? (
            <Grid container justify="center">
              <CircularProgress className={styles.loading} size={100} />
            </Grid>
          ) : (
            <SettlementScheduleForm
              // @ts-ignore
              isMobile={isMobile}
              goBack={() => back()}
              enableReinitialize
              initialValues={{
                schedule: schedule
                  ? schedule.map((sched) => ({
                      ...sched,
                      paymentAmount: Number(sched.paymentAmount).toFixed(2),
                      paidOff: Number(sched.paidOff).toFixed(2),
                    }))
                  : [],
              }}
              onSubmit={(scheduleObj: { schedule: any }) => {
                scheduleObj.schedule = scheduleObj.schedule.map((sched: any) => {
                  const dueDate = sched.paymentDueDate;
                  return {
                    ...sched,
                    paidOff: Number(sched.paidOff) || 0,
                    paymentDueDate:
                      typeof dueDate === 'string'
                        ? dueDate
                        : new Date(dueDate.getTime() - dueDate.getTimezoneOffset() * 60000)
                            .toISOString()
                            .split('T')[0],
                  };
                });

                return addSchedule(scheduleObj.schedule, debtData.id);
              }}
              submitPayment={(payment: PaymentSchedule) => addPayment(payment, debtData.id)}
            />
          )}
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state: AscendState) => ({
  debts: getDebtState(state),
  isMobile: state.layout.isMobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getDebt: (id: number) => dispatch({ type: FETCH_DEBT, id }),
  addDebt: (debt: Debt) => dispatch({ type: ADD_DEBT, debt }),
  back: () => dispatch(goBack()),
  addSchedule: (schedule: PaymentSchedule[], debtId: string) =>
    dispatch({ type: ADD_SCHEDULE, schedule, debtId }),
  addPayment: (payment: PaymentSchedule, debtId: string) =>
    dispatch({ type: ADD_PAYMENT, payment, debtId }),
});

export default connect<{}, {}, SettlementScheduleProps>(
  mapStateToProps,
  mapDispatchToProps
)(SettlementSchedule);
